// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@expo/webpack-config/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".swiper-container {\n  margin: 0;\n  overflow: visible;\n}\n", ""]);
// Exports
module.exports = exports;
